import axios from "axios";
import { BACKEND_URL } from "./LaConstants";
import { getAuthToken } from "./AuthTokenUtils";

export const laAxios = axios.create({
  baseURL: BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

laAxios.interceptors.request.use((config) => {
  const token = getAuthToken();

  if (token) {
    config.headers.Authorization = "Bearer " + token;
  } else {
    delete config.headers.Authorization;
  }

  return config;
});
